// import { t as t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { calculateAgeByDate, convertStringToJson, dateToString, decodeBase64, FormatCurrencys } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import { callGetContractByKey, callGetContractDetail, callGetPaymentByContractNumber, callGetPaymentDetailByContractNumber } from "../../../api/contract/service";
import DataAutoComplete from "../../../components/auto-complete";
import { Gallery, Item } from "react-photoswipe-gallery";
import "photoswipe/dist/photoswipe.css";
import { callExportLifeContractPDF } from "../../../api/export";
import moment from "moment";
import SwalAlert from "../../../components/common/alert";
import { useParams } from "react-router-dom";
import ImageGallery from "../../../components/image-view";
import BackPrevious from "../../../components/back-previous";
import SmartTable from "../../../components/common/table-component";
const groupPaymentDetails = (details = []) => {
	const grouped = {};

	details.forEach((item, index) => {
		let isPaidMonth = item.paidMonth
		let key = item.billNumber + `${Number(item.paidMonth)}-${Number(item.paidYear)}`;
		const nextItem = details[index + 1];
		if (item.paymentCode === 'paymentFee' && nextItem?.paymentCode === "LifePay" && item.paidMonth !== nextItem.paidMonth) {
			key = item.billNumber + `${Number(item.paidMonth) + 1}-${Number(item.paidYear)}`;
			isPaidMonth = Number(item.paidMonth) + 1;
		}

		if (!grouped[key]) {
			grouped[key] = {
				rowKey: key,
				id: item.id,
				billNumber: item.billNumber,
				paymentCode: item.paymentCode,
				payPerMonth: item.payPerMonth,
				paidMonth: isPaidMonth,
				paidYear: item.paidYear,
				totalDiscount: 0,
				commissionAmount: 0,
				companyReceivedAmount: 0,
				createdAt: item.createdAt,
				contractNumber: item.contractNumber,
				carriedCode: item.carriedCode,
				carriedName: item.carriedName,
				status: item.status,
				paymentId: item.paymentId,
				lifePay: 0,
				registerFee: 0,
				paymentFee: 0,
			};
		}

		const amount = Number(item.payPerMonth || 0);

		if (item.paymentCode === "LifePay") {
			grouped[key].lifePay = amount;
		}

		if (item.paymentCode === "registerFee") {
			grouped[key].registerFee = amount;
		}

		if (item.paymentCode === "paymentFee") {
			grouped[key].paymentFee = amount;
		}
		grouped[key].totalDiscount += Number(item.totalDiscount || 0);
		grouped[key].commissionAmount += Number(item.commissionAmount || 0);
		grouped[key].companyReceivedAmount += Number(item.companyReceivedAmount || 0);

	});
	console.log(grouped)

	return Object.values(grouped);
};

const LifeMonthlyPaymentDetail = ({ payment, FormatCurrencys }) => {

	const sortedDetails = [...(payment?.paymentDetails || [])].sort((a, b) => {
		const aMonth = Number(a.paidYear) * 12 + Number(a.paidMonth);
		const bMonth = Number(b.paidYear) * 12 + Number(b.paidMonth);

		return bMonth - aMonth;
	});
	const { t } = useTranslation();

	const rows = groupPaymentDetails(sortedDetails);
	// const rows = groupPaymentDetails(payment?.paymentDetails || []);

	const paidMonth = rows.filter(item => Number(item.status) === 1).length;

	const totalPay = rows.reduce((sum, item) => sum + Number(item.lifePay || 0), 0);
	const totalDiscount = rows.reduce((sum, item) => sum + Number(item.totalDiscount || 0), 0);
	const totalCommission = rows.reduce((sum, item) => sum + Number(item.commissionAmount || 0), 0);
	const totalCompanyReceived = rows.reduce((sum, item) => sum + Number(item.companyReceivedAmount || 0), 0);
	const totalRegisterFee = rows.reduce((sum, item) => sum + Number(item.registerFee || 0), 0);
	const totalPaymentFee = rows.reduce((sum, item) => sum + Number(item.paymentFee || 0), 0);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(5);

	const totalPage = Math.ceil(rows.length / limit);

	const paginatedRows = rows.slice(
		(page - 1) * limit,
		page * limit
	);
	return (
		<div className="life-payment-card">
			<div className="life-payment-header">
				<div className="life-payment-title">
					<h4>{t("uiText.text226")}</h4>
					<small>{t("uiText.text227")}{payment?.contractNumber || "-"}</small>
				</div>

				<div className="life-payment-badge">
					{t("uiText.text228")}{rows.length} {t("uiText.text040")}</div>
			</div>

			<div className="life-payment-summary">
				<div className="life-payment-summary-card">
					<small>{t("uiText.text229")}</small>
					<h5>{rows.length}</h5>
				</div>

				<div className="life-payment-summary-card">
					<small>{t("uiText.text230")}</small>
					<h5 className="text-success">{paidMonth}</h5>
				</div>

				<div className="life-payment-summary-card">
					<small>{t("uiText.text231")}</small>
					<h5>{FormatCurrencys(totalPay)} {t("uiText.text232")}</h5>
				</div>

				<div className="life-payment-summary-card">
					<small>{t("uiText.text233")}</small>
					<h5 className="text-success">{FormatCurrencys(totalCompanyReceived)} {t("uiText.text232")}</h5>
				</div>
			</div>

			<SmartTable
				columns={[
					{ label: t("uiLabels.billNumber"), key: "billNumber", render: (val) => <div className="life-payment-bill">{val || "-"}</div> },
					{ label: t("uiLabels.monthYear"), key: "paidMonth", className: "text-center", render: (val, row) => `${String(val).padStart(2, "0")}/${row.paidYear}` },
					{ label: t("uiLabels.premium"), key: "lifePay", className: "text-end", render: (val) => t("uiText.text234", { value1: FormatCurrencys(val || 0) }) },
					{ label: t("uiLabels.registrationFee"), key: "registerFee", className: "text-end", render: (val) => t("uiText.text234", { value1: FormatCurrencys(val || 0) }) },
					{ label: t("uiLabels.transferFee"), key: "paymentFee", className: "text-end", render: (val) => t("uiText.text234", { value1: FormatCurrencys(val || 0) }) },
					{ label: t("uiLabels.discount"), key: "totalDiscount", className: "text-end text-danger", render: (val) => t("uiText.text234", { value1: FormatCurrencys(val || 0) }) },
					{ label: t("uiLabels.commission"), key: "commissionAmount", className: "text-end text-danger", render: (val) => t("uiText.text234", { value1: FormatCurrencys(val || 0) }) },
					{ label: t("uiLabels.companyReceived"), key: "companyReceivedAmount", className: "text-end fw-bold text-success", render: (val) => t("uiText.text234", { value1: FormatCurrencys(val || 0) }) },
					{ label: t("uiLabels.payee"), key: "carriedName", render: (val, row) => <><div className="life-payment-user">{val || "-"}</div><div className="life-payment-code">{row.carriedCode ? `Code: ${row.carriedCode}` : ""}</div></> },
					{ label: t("uiLabels.status"), key: "status", className: "text-center", render: (val) => Number(val) === 1 ? <span className="badge bg-success">{t("uiText.text230")}</span> : <span className="badge bg-danger">{t("uiText.text235")}</span> },
					{ label: t("uiLabels.date"), key: "createdAt", render: (val) => val ? dateToString(val, "DD/MM/YYYY HH:mm") : "-" },
				]}
				data={{ result: paginatedRows }}
				rowKey="rowKey"
				recordsTableFilter={false}
				customPagination={false}
				showRowNumber={true}
				rowNumberOffset={(page - 1) * limit}
				footer={
					<tr>
						<th colSpan="3" className="text-end">{t("uiText.text228")}</th>
						<th className="text-end">{FormatCurrencys(totalPay)} {t("uiText.text232")}</th>
						<th className="text-end">{FormatCurrencys(totalRegisterFee)} {t("uiText.text232")}</th>
						<th className="text-end">{FormatCurrencys(totalPaymentFee)} {t("uiText.text232")}</th>
						<th className="text-end text-danger">{FormatCurrencys(totalDiscount)} {t("uiText.text232")}</th>
						<th className="text-end text-danger">{FormatCurrencys(totalCommission)} {t("uiText.text232")}</th>
						<th className="text-end text-success">{FormatCurrencys(totalCompanyReceived)} {t("uiText.text232")}</th>
						<th colSpan="3"></th>
					</tr>
				}
			/>
			<div className="life-payment-pagination">
				<div className="life-payment-page-info">
					{t("uiText.text038")}{(page - 1) * limit + 1} - {Math.min(page * limit, rows.length)}
					{" "}{t("uiText.text039")}{rows.length} {t("uiText.text040")}</div>

				<div className="life-payment-page-actions">
					<select
						className="form-control-uld life-payment-page-select"
						value={limit}
						onChange={(e) => {
							setLimit(Number(e.target.value));
							setPage(1);
						}}
					>
						<option value={5}>{t("uiText.text236")}</option>
						<option value={10}>{t("uiText.text237")}</option>
						<option value={20}>{t("uiText.text238")}</option>
					</select>

					<button
						type="button"
						className="life-payment-page-btn"
						disabled={page <= 1}
						onClick={() => setPage(prev => Math.max(prev - 1, 1))}
					>
						{t("uiText.text239")}</button>

					<span className="life-payment-page-number">
						{page} / {totalPage || 1}
					</span>

					<button
						type="button"
						className="life-payment-page-btn"
						disabled={page >= totalPage}
						onClick={() => setPage(prev => Math.min(prev + 1, totalPage))}
					>
						{t("uiText.text240")}</button>
				</div>
			</div>
		</div>
	);
};
const Index = () => {
	const { t } = useTranslation();

	const dispatch = useDispatch();
	const [contractList, setContractList] = useState([]);
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '' });
	const [contract, setContract] = useState(null);
	const [initValue, setInitValue] = useState(null);
	const [payment, setPayment] = useState(null);

	let params = useParams();
	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let res = decodeBase64(params?.data)
			if (res != null) {
				let data = convertStringToJson(res)
				console.log(data)
				setInitValue({ ...data, contractNumber: data.contractNumber, customerId: data.customerId, id: data.contractNumber, label: data.fullName })
			}
		}

	}, []);

	const loadData = async (value) => {
		if (value.length > 2) {
			let data = { keyword: value, page: request.page, maxResult: request.maxResult, insuranceType: 1 };
			const rsp = await dispatch(callGetContractByKey(data));
			if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
				setContractList(rsp.payload.data.result)
			}
		}
	};

	const onSelect = async (item) => {
		if (item) {
			let data = { contractNumber: item.id, customerId: item.customerId, insuranceType: 1 };
			const rsp = await dispatch(callGetContractDetail(data));
			console.log(rsp?.payload?.data)
			if (rsp?.payload?.responseCode === "00000") {
				setContract(prev => ({ ...item, ...prev, ...rsp?.payload?.data, documentImagePath: convertStringToJson(item.documentImagePath) }));
				loadDataPayment(item.id, item);
			}
		} else {
			setContract(null)
		}
	}
	const downloadPDF = async (contract) => {
		try {
			let data = { contract: contract };
			let response = await callExportLifeContractPDF(data);
			if (response === null) {
				SwalAlert.error(t("uiText.text023"), t("uiText.text025"));
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = `${contract}.pdf`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};
	const getUnpaidMonths = (paymentDetails = [], payPerMonth = 0, contractNumber = "") => {
		const now = new Date();
		const currentMonth = now.getMonth() + 1; // 1-12
		const currentYear = now.getFullYear();

		if (!paymentDetails.length) return [];

		const latestPaid = [...paymentDetails]
			.filter(item => Number(item.status) === 1)
			.sort((a, b) => {
				const aValue = Number(a.paidYear) * 12 + Number(a.paidMonth);
				const bValue = Number(b.paidYear) * 12 + Number(b.paidMonth);
				return bValue - aValue;
			})[0];

		if (!latestPaid) return [];

		let month = Number(latestPaid.paidMonth) + 1;
		let year = Number(latestPaid.paidYear);

		if (month > 12) {
			month = 1;
			year += 1;
		}

		const unpaidMonths = [];

		while (year < currentYear || (year === currentYear && month <= currentMonth)) {
			unpaidMonths.push({
				id: `unpaid-${year}-${month}`,
				billNumber: null,
				paymentCode: "LifePay",
				payPerMonth,
				paidMonth: month,
				paidYear: year,
				totalDiscount: 0,
				commissionAmount: 0,
				companyReceivedAmount: 0,
				createdAt: null,
				contractNumber,
				carriedCode: null,
				carriedName: null,
				status: 0,
				paymentId: null,
				isUnpaidGenerated: true
			});

			month += 1;

			if (month > 12) {
				month = 1;
				year += 1;
			}
		}

		return unpaidMonths;
	};
	const loadDataPayment = async (contractNumber, contract) => {
		let dataPayment = await dispatch(callGetPaymentDetailByContractNumber({ contractNumber: contractNumber }))

		if (dataPayment?.payload?.responseCode === "00000") {
			let data = dataPayment?.payload?.data.sort((a, b) => {
				const aValue = Number(a.paidYear) * 12 + Number(a.paidMonth);
				const bValue = Number(b.paidYear) * 12 + Number(b.paidMonth);
				return aValue - bValue;
			})
			const unpaid = getUnpaidMonths(
				data,
				contract?.payPerMonth,
				contract?.contractNumber
			);
			setPayment({
				payPerMonth: contract?.payPerMonth,
				contractNumber: contract?.contractNumber,
				paymentDetails: [
					...data,
					...unpaid,
				]
			});
		}

	};
	// const InfoItem = ({ label, value }) => (
	// 	<div className="life-info-item">
	// 		<div className="life-info-label">{label}</div>
	// 		<div className="life-info-value">{value || "-"}</div>
	// 	</div>
	// );
	const InfoItem = ({
		label,
		value,
		rightLabel,
		rightValue,
		icon,
		status,
		full = false,
	}) => (
		<div className={`life-info-item ${full ? "full" : ""}`}>
			{(rightLabel || rightValue) ? <div className="life-info-row">
				<div className="life-info-left">
					{icon && (
						<div className="life-info-icon">
							<i className={icon}></i>
						</div>
					)}

					<div>
						<div className="life-info-label">{label}</div>
						<div className="life-info-value">{value || "-"}</div>
					</div>
				</div>

				<div className="life-info-right">
					<div className="life-info-label">{rightLabel}</div>
					<div className="life-info-value right">{rightValue || "-"}</div>
				</div>

				{status && (
					<div className={`life-info-status ${status.type || ""}`}>
						{status.text}
					</div>
				)}
			</div> : <div>
				<div className="life-info-label">{label}</div>
				<div className="life-info-value">{value || "-"}</div>
			</div>}
		</div>
	);

	const StatCard = ({ title, value, icon, color }) => (
		<div className="life-stat-card">
			<div className="life-stat-icon" style={{ background: color }}>
				<i className={icon}></i>
			</div>
			<div>
				<div className="life-stat-title">{title}</div>
				<div className="life-stat-value">{value}</div>
			</div>
		</div>
	);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box back-title-group">
						{Object.keys(params).length > 0 && <BackPrevious />}
						<h4>{t("menu.contractControl.checkLifeContract")}</h4>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-12">
													<div className="form-group">
														<label> {t('contract.search')} <span className="text-danger">*</span> </label>
														<DataAutoComplete
															initialData={initValue}
															data={contractList}
															placeholder={t('contract.keyword')}
															handleChange={loadData}
															onSelect={onSelect}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					{contract && <div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<section className="candidate-detail-section">
											<div className="life-contract-wrapper">

												<div className="life-hero-card">
													<div className="life-hero-top">
														<div className="life-profile">
															<div className="life-avatar">
																<i className={"icon icon-user-2"}></i>
															</div>

															<div>
																<h2 className="life-name">
																	{(contract.gender === "f" ? t("uiText.text241") : t("uiText.text242")) + contract.fullName}
																</h2>

																<div className="life-sub-info">
																	<span>📞 {contract.phone || "-"}</span>
																	<span>📍 {contract.address || "-"}</span>
																	<span>👤 {t("contract.gender." + contract.gender)}</span>
																</div>
															</div>
														</div>

														<div className="life-price-box">
															<div className="life-price-label">{t("uiText.text243")}</div>
															<div className="life-price-value">
																{FormatCurrencys(contract.payPerMonth)} {t("uiText.text232")}</div>
															<div>{t("contract.package")} {contract.ageRange} {t("title.year")}</div>

															<button
																className="theme-btn btn-style-one mt-3"
																onClick={() => downloadPDF(contract.contractNumber)}
															>
																{t("button.downloadPDF")}
															</button>
														</div>
													</div>

													<div className="life-badge-row">
														<span className="life-pill">{t("uiText.text227")}{contract.contractNumber || "-"}</span>
														<span className="life-pill">{t("uiText.text244")}{contract.agentCode || "-"}</span>
														<span className="life-pill">
															{t("contract.docType." + contract.documentTypeId)}: {contract.documentNo || "-"}
														</span>
													</div>
												</div>

												<div className="life-stats-grid">
													<StatCard
														title={t("contract.signDate")}
														value={dateToString(contract.signedDate, "DD/MM/YYYY")}
														icon="pi pi-calendar"
														color="#087a52"
													/>

													<StatCard
														title={t("contract.age")}
														value={`${calculateAgeByDate(contract.dateOfBirth, contract.signedDate)} ${t("title.year")}`}
														icon="pi pi-user"
														color="#f59e0b"
													/>

													<StatCard
														title={t("contract.totalPayMonth")}
														value={`${contract.totalPayMonth || 0} ${t("title.month")}`}
														icon="pi pi-wallet"
														color="#10b981"
													/>

													<StatCard
														title={t("contract.lastPayDate")}
														value={contract.lastPay || t("noPay")}
														icon="pi pi-clock"
														color="#ef4444"
													/>
												</div>

												<div className="life-main-grid">
													<div>
														<div className="life-card">
															<div className="life-card-title">
																<h4>{t("uiText.text245")}</h4>
															</div>

															<div className="life-info-grid">
																<InfoItem label={t("contract.gender.label")} value={t("contract.gender." + contract.gender)} />
																<InfoItem label={t("contract.dateOfBirth")} value={dateToString(contract.dateOfBirth, "DD/MM/YYYY")} />
																<InfoItem label={t("contract.phone")} value={contract.phone} />
																<InfoItem label={t("contract.address")} value={contract.address} />
																<InfoItem label={t("contract.docType." + contract.documentTypeId)} value={contract.documentNo} rightLabel={t("uiText.text246")} rightValue={dateToString(contract.issueDate, "DD/MM/YYYY") || "-"} />
																<InfoItem label={t("contract.homeNumber")} value={contract.homeNumber} />
																<InfoItem label={t("contract.unitNumber")} value={contract.unitNumber} />
																<InfoItem label={t("contract.agentCode")} value={contract.agentCode} />
															</div>
														</div>

														<div className="life-card">
															<div className="life-card-title">
																<h4>{t("contract.documentImage")}</h4>
															</div>
															<div className="vehicle-document-slider">
																<ImageGallery paths={contract?.documentImagePath} />
															</div>
														</div>
													</div>

													<div>
														<div className="life-card">
															<div className="life-card-title">
																<h4>{t("uiText.text247")}</h4>
															</div>

															<div className="life-side-list">
																<div className="life-side-item">
																	<div className="life-side-label">{t("contract.contractNumber")}</div>
																	<div className="life-side-value">{contract.contractNumber || "-"}</div>
																</div>

																<div className="life-side-item">
																	<div className="life-side-label">{t("contract.package")}</div>
																	<div className="life-side-value">
																		{contract.ageRange} {t("title.year")}
																	</div>
																</div>

																<div className="life-side-item">
																	<div className="life-side-label">{t("uiText.text248")}</div>
																	<div className="life-side-value">
																		{FormatCurrencys(contract.payPerMonth)} {t("currentcy.kip")}
																	</div>
																</div>

																<div className="life-side-item">
																	<div className="life-side-label">{t("contract.signDate")}</div>
																	<div className="life-side-value">
																		{dateToString(contract.signedDate, "DD/MM/YYYY")}
																	</div>
																</div>

																<div className="life-side-item">
																	<div className="life-side-label">{t("contract.lastPayDate")}</div>
																	<div className="life-side-value">
																		{contract.lastPay || t("noPay")}
																	</div>
																</div>

																<div className="life-side-item">
																	<div className="life-side-label">{t("contract.totalPayMonth")}</div>
																	<div className="life-side-value">
																		{contract.totalPayMonth || 0} {t("title.month")}
																	</div>
																</div>

																<div className="life-side-item">
																	<div className="life-side-label">{t("contract.agentCode")}</div>
																	<div className="life-side-value">
																		{contract.agentCode || "-"}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												{/* HEIR FOOTER */}
												<div className="life-card life-heir-footer">
													<div className="life-card-title">
														<h4>{t("contract.heir")}</h4>
													</div>

													<div className="life-heir-footer-grid">
														{[0, 1].map((_, index) => {
															const item = contract.heir?.[index];

															if (!item) {
																return (
																	<div className="life-heir-footer-card life-heir-empty-card" key={index}>
																		<div className="life-section-muted">
																			{t("contract.heirs." + (index + 1))}
																		</div>

																		<div className="life-heir-empty">
																			{t("uiText.text249")}</div>
																	</div>
																);
															}

															return (
																<div className="life-heir-footer-card" key={item.id || index}>
																	<div className="life-heir-header">
																		<div>
																			<div className="life-section-muted">
																				{t("contract.heirs." + (index + 1))}
																			</div>

																			<div className="life-heir-name">
																				{item.firstName} {item.lastName}
																			</div>
																		</div>

																		<div className="life-relation-badge">
																			{t("contract.relation." + item.relation)}
																		</div>
																	</div>

																	<div className="life-heir-footer-info">
																		<InfoItem label={t("contract.phone")} value={item.phone} />
																		<InfoItem label={t("contract.age")} value={item.age ? `${item.age} ${t("title.year")}` : "-"} />
																		<InfoItem label={t("contract.docType." + item.documentTypeId)} value={item.documentNo} rightLabel={t("uiText.text246")} rightValue={dateToString(item.issueDate, "DD/MM/YYYY") || "-"} />
																		<InfoItem label={t("contract.homeNumber")} value={item.homeNumber} />
																		<InfoItem label={t("contract.unitNumber")} value={item.unitNumber} />
																		<InfoItem label={t("contract.address")} value={item.address} />
																	</div>

																	<div className="mt-3">
																		<div className="life-section-muted">
																			{t("contract.documentImage")}
																		</div>
																		<div className="vehicle-document-slider">
																			<ImageGallery paths={convertStringToJson(item?.documentImagePath)} />
																		</div>
																	</div>
																</div>
															);
														})}
													</div>
												</div>
											</div>
											{payment && (
												<LifeMonthlyPaymentDetail
													payment={payment}
													FormatCurrencys={FormatCurrencys}
												/>
											)}
										</section>
									</div>
								</div>
							</div>
						</div>
					</div>}
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
